// extracted by mini-css-extract-plugin
export default {"savedTimeContainer":"SavedTime_savedTimeContainer__pEzbg"};